import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=5d8b5cba&scoped=true&"
import script from "./DropZone.vue?vue&type=script&lang=ts&"
export * from "./DropZone.vue?vue&type=script&lang=ts&"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=5d8b5cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8b5cba",
  null
  
)

export default component.exports